// windowFunctions.js - Centralized window function assignments extracted from App.js
import { generateMovieUrl } from './urlUtils';

export const setupWindowFunctions = ({
  // Navigation functions
  navigate,

  // Modal functions
  modal,

  // Form functions
  form,
  resetFormsWithImages,
  resetReleaseForm,

  // VHS Data functions
  vhsData,
  removeFromCollection,
  removeFromCollectionAndMarketplace,
  handleDeleteMasterItem,
  handleEditMasterItem,
  setAvailableReleases,
  loadUserCollection,
  loadActivityFeed,

  // Database
  supabase,

  // Other dependencies
  setNewCollectionItem,
}) => {
  // Collection management functions
  window.removeFromCollection = collectionItemId => {
    removeFromCollection(collectionItemId);
  };

  // Modal management functions
  window.openPosterModal = (posterUrl, title) => {
    modal.openImageModal(posterUrl, '');
  };

  // Navigation functions
  window.openMovieDetail = movie => {
    const url = generateMovieUrl(movie, 'catalog');
    navigate(url);
  };

  // Edit functions with multiple aliases
  window.onEditItem = async item => {
    // Clear any existing state first
    form.setSelectedMasterImages([]);
    form.setEditingMasterItem(null);

    // Set form state with the item data
    const editItem = handleEditMasterItem(item);

    try {
      // Load existing images for this item
      const existingImages = await vhsData.loadMasterItemImages(item.id);
      let imagesToLoad = [];

      if (existingImages.length > 0) {
        imagesToLoad = existingImages;
      } else if (item.cover_image_url) {
        const fallbackImage = {
          id: 'existing-cover',
          url: item.cover_image_url,
          preview: item.cover_image_url,
          caption: 'Original Cover Image',
          isPrimary: true,
          order: 1,
          isNew: false,
          file: null,
        };
        imagesToLoad = [fallbackImage];
      }

      // Set editing item and images
      form.setEditingMasterItem(editItem);
      form.setSelectedMasterImages(imagesToLoad);

      // Show the edit modal
      modal.openAddMasterModal(form.editingMasterItem, form.isDataFromSearch);
    } catch (error) {
      console.error('Error loading master item images:', error);
      form.setSelectedMasterImages([]);
      form.setEditingMasterItem(editItem);
      modal.openAddMasterModal(form.editingMasterItem, form.isDataFromSearch);
    }
  };

  // Edit function aliases
  window.openEditModal = window.onEditItem; // Some components call this instead

  // Delete functions with multiple aliases
  window.onDeleteItem = itemId => {
    vhsData.handleDeleteMasterItem(itemId);
  };

  window.deleteItem = window.onDeleteItem; // Some components use this name instead

  // Collection functions
  window.addToCollectionWithRelease = async (releaseId, notes) => {
    try {
      await vhsData.addToCollectionWithRelease(releaseId, notes || '');
      // Note: Success alert is already shown by vhsData.addToCollectionWithRelease
      // Reload user collection to update UI
      await vhsData.loadUserCollection();
    } catch (error) {
      console.error('Error adding to collection:', error);
      alert('Error adding to collection: ' + error.message);
    }
  };

  // Add to collection modal function
  window.openAddToCollectionModal = async item => {
    form.setSelectedMasterItem(item);

    // Load releases for this movie
    try {
      const releases = await vhsData.loadMovieReleases(item.id);
      setAvailableReleases(releases || []);

      // Don't auto-select any releases - let user choose which ones they want

      modal.openAddToCollectionModal(form.selectedMasterItem);
    } catch (error) {
      console.error('Error loading releases:', error);
      setAvailableReleases([]);
      modal.openAddToCollectionModal(form.selectedMasterItem);
    }
  };

  // Form reset functions for extracted components
  window.resetFormsWithImages = resetFormsWithImages;
  window.resetReleaseForm = resetReleaseForm;

  // Activity feed function for extracted CommunityHandler
  window.loadActivityFeed = loadActivityFeed;
};
